/* eslint-disable @typescript-eslint/no-explicit-any */
import L from 'leaflet';

/**
 * 只做一件事: 把 Leaflet 挂成全局 `L`。
 *
 * <p>必须是独立模块 —— ES import 会被提升, 所以"同一个文件里先赋值 window.L 再 import 插件"
 * 是无效的 (插件模块体先跑)。插件依赖全局 L 的地方:
 * <ul>
 *   <li>leaflet-draw@1.0.4 的 dist 是裸脚本, 首行 {@code L.drawVersion=...};</li>
 *   <li>leaflet.gridlayer.googlemutant 末尾的工厂注册块 {@code if (L && L.gridLayer)}。</li>
 * </ul>
 */
(window as any).L = L;

export default L;
